import styled from "styled-components";

const TitleHeading = styled.h1`
  font-family: var(--font-family);
  font-size: 24px;
  color: var(--text-color-main);
  padding: 0;
  margin: 0;
`

export default TitleHeading